<template>
  <div
    class="modal fade program-modal"
    id="modal-program-4"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div
      class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
    >
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-x-lg"
              viewBox="0 0 16 16"
            >
              <path
                d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
              />
            </svg>
          </button>

          <carousel
            :loop="true"
            :nav="false"
            :dots="false"
            :responsive="responsive"
          >
            <div v-for="row in pemberdayaanekonomi" :key="row.id" class="item">
              <div class="row">
                <div class="col-12">
                  <div>
                    <div class="program-subtitle-modal">
                      Program Pemberdayaan Ekonomi
                    </div>
                    <div class="program-title-modal capitalize">
                      {{ row.title.toLowerCase() || "Pemberdayaan Ekonomi" }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div>
                    <img
                      v-if="row.img"
                      :src="row.img ? row.img : '/img/img-program-4.svg'"
                      class="program-image"
                    />
                    <p
                      class="no-margin"
                      style="margin-bottom: 10px !important;"
                    >
                      {{
                        row.desc_short ||
                          ` Memberdayakan masyarakat di lingkungan masjed untuk
                            mendorong keuangan umat dengan mengajak masyarakat sekitar
                            masjed untuk berpartisipasi dalam usaha serambi masjed.`
                      }}
                    </p>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div>
                    <div v-if="nominal" class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="email"
                            ><strong>Nominal Donasi</strong></label
                          >
                          <vue-numeric
                            placeholder="Masukan Nominal"
                            class="form-control"
                            currency="Rp."
                            separator="."
                            v-model="nominal"
                          ></vue-numeric>
                        </div>
                      </div>
                      <div class="col-12 col-md-12">
                        <div class="form-nominal">
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': nominal === 10000,
                            }"
                            @click="setNominal(10000)"
                          >
                            <div class="nominal">Rp. 10.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': nominal === 20000,
                            }"
                            @click="setNominal(20000)"
                          >
                            <div class="nominal">Rp. 20.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': nominal === 50000,
                            }"
                            @click="setNominal(50000)"
                          >
                            <div class="nominal">Rp. 50.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': nominal === 100000,
                            }"
                            @click="setNominal(100000)"
                          >
                            <div class="nominal">Rp. 100.000</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <center>
                      <a
                        href="javascript:void(0)"
                        class="
                      btn btn-main btn-wide
                      d-block d-md-inline-block
                      mt-32
                    "
                        @click="danai(row.id, row.title, row.slug)"
                        >Tunaikan Sekarang</a
                      >
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../utils/api";
import carousel from "vue-owl-carousel";
import Layout from "../../views/layouts/Index.vue";
import { mapActions, mapState } from "vuex";
import VueNumeric from "vue-numeric";

export default {
  name: "infrastruktur_masjid",
  data() {
    return {
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        1140: {
          items: 1,
        },
      },
      link: {
        program: "/program",
        carimasjid: "/cari-masjid",
        zuhra:
          "/donasi-baju-baru/ayo-wujudkan-baju-baru-untuk-1000-yatim-piatu",
        cahayamasjid: "/program/sejuta-cahaya-masjed",
      },
      osDevice: null,
      osBrowser: null,
      nominal: 0,
      newData: [],
    };
  },
  components: {
    Layout,
    carousel,
    VueNumeric,
  },
  methods: {
    ...mapActions("transactions", ["resetForm", "setInitialTransaction"]),
    ...mapActions(["setPemberdayaan"]),
    async danai(programid, title, slug) {
      const detail = await axios.get(
        `/detailcampaign?slug=${slug.toLowerCase()}`
      );
      const payload = {
        program: {
          programId: programid || "",
          programTitle: title || "",
          nominalDonasi: this.nominal,
        },
        user: {
          namaDonatur: "Hamba Allah",
          emailDonatur: "deddy@dompetdhuafa.org",
          teleponDonatur: "08118625234",
          doaDonatur: "Bismillah, Semoga Berkah.",
        },
      };

      this.setInitialTransaction(payload);

      location.href = `/pembayaran-custom/${slug.toLowerCase()}`;
    },
    async fetchProgram() {
      const campaigns = await axios.get(
        `/getcampaign?page=1&limit=9&kategori=4`
      );
      const { data } = campaigns.data;
      this.data = data;

      const self = this;
      this.data.forEach((element) => {
        self.newData.push(element.campaign);
      });

      this.setPemberdayaan(self.newData);
    },
    setNominal(val) {
      this.nominal = val;
    },
  },
  mounted() {
    this.nominal = 10000;
    this.fetchProgram();
  },
  computed: {
    ...mapState(["pemberdayaanekonomi"]),
  },
};
</script>
<style lang="scss" scoped>
.modal-body {
  /* width */
  &::-webkit-scrollbar {
    width: 10px;
    height: 3px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    border-radius: 5px;
    background: #f4f4f4;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #28a745;
    border-radius: 20px;
    max-height: 10px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #28a745;
  }
}

.capitalize {
  text-transform: capitalize !important;
}

.program-image {
  border-radius: 20px;
  margin-bottom: 15px !important;
}

.program-subtitle-modal {
  margin-bottom: 5px !important;
  @media only screen and (max-width: 320px) {
    font-size: 0.9rem;
    margin: 0px;
  }
  @media only screen and (min-width: 321px) and (max-width: 375px) {
    font-size: 0.9rem;
    margin: 0px;
  }
  @media only screen and (min-width: 376px) and (max-width: 480px) {
    font-size: 0.9rem;
    margin: 0px;
  }
  @media only screen and (min-width: 481px) and (max-width: 768px) {
    font-size: 1rem;
    margin: 0px;
  }
}

.program-title-modal {
  margin-bottom: 15px !important;
  @media only screen and (max-width: 320px) {
    font-size: 1.4rem;
    margin: 0px;
    line-height: 28px;
  }
  @media only screen and (min-width: 321px) and (max-width: 375px) {
    font-size: 1.5rem;
    margin: 0px;
    line-height: 28px;
  }
  @media only screen and (min-width: 376px) and (max-width: 480px) {
    font-size: 1.6rem;
    margin: 0px;
    line-height: 28px;
  }
  @media only screen and (min-width: 481px) and (max-width: 768px) {
    font-size: 1.8rem;
    margin: 0px;
    line-height: 35px;
  }
}

.modal-body {
  @media only screen and (max-width: 320px) {
    padding: 10px;
  }
  @media only screen and (min-width: 321px) and (max-width: 375px) {
    padding: 10px;
  }
  @media only screen and (min-width: 376px) and (max-width: 480px) {
    padding: 10px;
  }
}
</style>
